import type { User } from "firebase/auth";
import { mountTowerPage } from "@/mount-tower-page";
import { setTowerImmersiveBattle } from "@/tower/tower-immersive-battle";

let activeClose: (() => void) | null = null;

export function isTowerModalOpen(): boolean {
  return Boolean(document.querySelector(".tower-modal"));
}

/** Tower lobby + battle as overlay on home (does not navigate away). */
export async function openTowerModal(user: User): Promise<() => void> {
  if (activeClose) {
    return activeClose;
  }

  const overlay = document.createElement("div");
  overlay.className = "tower-modal";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", "หอ 100 ชั้น");

  const backdrop = document.createElement("button");
  backdrop.type = "button";
  backdrop.className = "tower-modal-backdrop";
  backdrop.setAttribute("aria-label", "ปิดหอคอย");

  const shell = document.createElement("div");
  shell.className = "tower-modal-shell";

  overlay.append(backdrop, shell);
  document.body.appendChild(overlay);
  document.body.classList.add("has-tower-modal");

  let pageTeardown: (() => void) | null = null;
  let allowBackdropClose = true;

  const close = () => {
    if (!allowBackdropClose) return;
    pageTeardown?.();
    pageTeardown = null;
    overlay.remove();
    document.body.classList.remove("has-tower-modal");
    setTowerImmersiveBattle(false);
    activeClose = null;
    window.removeEventListener("keydown", onKeyDown);
  };

  activeClose = close;

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key !== "Escape") return;
    close();
  };
  window.addEventListener("keydown", onKeyDown);

  backdrop.addEventListener("click", () => close());

  pageTeardown = await mountTowerPage(shell, user, {
    asModal: true,
    onRequestClose: close,
    onBattleActiveChange: (active) => {
      allowBackdropClose = !active;
      overlay.classList.toggle("tower-modal--battle", active);
      setTowerImmersiveBattle(active);
    },
  });

  return close;
}
